import qs from 'qs';
import { network } from 'services/network';

export const duplicatePoapView = ({ viewId, viewName }: QueryParams) => {
    const querystring = qs.stringify({ viewId, viewName }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/duplicatePoapView${querystring}`;
    return network.post(url).then((response) => response.data);
};

export interface QueryParams {
    viewId: number;
    viewName: string;
}
